import { useSelector } from "react-redux";
import "./Alert.css";
import Lottie from "react-lottie";
import successData from "./success.json";
import loadingData from "./loading.json";
import errorData from "./error.json";

const Alert = () => {
  const alertShow = useSelector((state) => state.alertShow);
  const { alertState } = alertShow;

  if (!alertState || Object.keys(alertState).length === 0) return null;

  const defaultOptions = {
    loop: alertState.alertType === "loading",
    autoplay: true,
    animationData:
      alertState.alertType === "success"
        ? successData
        : alertState.alertType === "error"
        ? errorData
        : loadingData,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
  };

  return (
    <div className="alert">
      <div className="alertbody">
        <Lottie options={defaultOptions} height={40} width={40} />
        <div className="alerttitle">{alertState.message}</div>
      </div>
    </div>
  );
};

export default Alert;
